import ErrorBoundary from '../errorboundary/errorboundary'
import { H3Title, Paragraph } from '../typography/typography'
import { AppButton } from '../buttons/button'
import Icon from '../icon/icons'

const Modal = ({ children, handleClose, title, subTitle, noheader, handleButtonClick, buttonText, buttonIcon, loading, borderless, status, className = "" }) => {
  return (
    <div onClick={handleClose} className='fixed py-4 px-2 md:p-5 top-0 left-0 w-full h-full bg-black/[.29] flex justify-center items-center dark:bg-blackshade/[.29] z-[1000]'>
        <div 
          className={`bg-white dark:bg-brand-deep w-full max-w-md lg:w-2/6 rounded-lg max-h-fit dark:bg-darkbg shadow-lg ${className}`}
          onClick={(e) => e.stopPropagation()}
        >
          {!noheader ? (
            <div className={`flex justify-between items-center pt-5 px-4 ${borderless ? "" : "border-b border-grey-light pb-4"} `}>
              <div className="flex-1">
                <H3Title size='sm' className="!text-black font-medium">{title}</H3Title>
                {subTitle && (
                  <Paragraph size='base' className="text-grey-dark mt-1">
                    {subTitle}
                  </Paragraph>
                )}
              </div>
              <button
                onClick={handleClose}
                className="text-blue-500 border border-grey-200 transition-colors ml-4 flex-shrink-0 p-1 rounded-md hover:bg-grey-light"
                aria-label="Close modal"
              >
                <Icon name="close" iconClass="w-5 h-5" />
              </button>
            </div>
            ) : (
              <div className='flex justify-between items-start pt-5 px-4'>
              <div className="flex-1"></div>
              <button
                onClick={handleClose}
                className="text-grey-dark hover:text-black dark:text-grey-850 dark:hover:text-white transition-colors ml-4 flex-shrink-0 p-1 rounded-md hover:bg-grey-light"
                aria-label="Close modal"
              >
                <Icon name="close" iconClass="w-5 h-5" />
              </button>
            </div>)
          }
          <div className='py-5 overflow-y-auto max-h-[70vh] client-overflow-scroll px-4'>
            <ErrorBoundary>
              { children }
            </ErrorBoundary>
          </div>
          {buttonText && (
            <div className={`flex justify-between items-start pt-5 pb-5 px-4 ${borderless ? "" : "border-t border-grey-200"}`}>
              <AppButton 
                radius="md" 
                loading={loading} 
                disabled={loading} 
                onClick={() => handleButtonClick()} 
                size="md" 
                textSize="md" 
                className="!mt-0 !py-3 !px-4" 
                leftIcon={buttonIcon}
              >
                {buttonText}
              </AppButton>
            </div>
          )}
        </div>
    </div>
  )
}

export default Modal
